import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import { TextField } from 'components/widgets';
import css from './DescriptionField.css';

const translationPrefix = 'STATIC.PAGES.PARTNER_INFORMATION';
const MAX_DESCRIPTION_LENGTH = 500;

const DescriptionField = ({ value, onChange, translate }) => {
    const wrapperRef = useRef(null);

    useEffect(() => {
        const textarea = wrapperRef.current?.querySelector('textarea');
        if (textarea) {
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    }, [value]);

    return (
        <div ref={wrapperRef}>
            <TextField
                value={value}
                onChange={onChange}
                type="textarea"
                maxLength={MAX_DESCRIPTION_LENGTH}
                maxLengthForCounter={MAX_DESCRIPTION_LENGTH}
                showCharCount
                inputClassName={css.textarea}
                inputConfig={{
                    placeholder: translate(`${translationPrefix}.DESCRIPTION_PLACEHOLDER`),
                    rows: 4,
                }}
            />
        </div>
    );
};

DescriptionField.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(DescriptionField);
